import { actions, selectors as sharedSelectors } from "@shared/store";
import { MODAL_TYPES, NameOfChildRoutes } from "@shared/constants";
import { ModalSize } from "@shared/interfaces";
import { actions as AccountActions } from "@containers/Account/store";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Account } from "@shared/models";
import { useNavigate } from "react-router-dom";
import { checkIfSuperAdmin } from "@shared/utils/ACL";

export const useDeleteCompany = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeUser = useSelector(sharedSelectors.getUserDetails());
  const isSuperAdmin = checkIfSuperAdmin(activeUser!);

  return useCallback(
    (contact: Account) => {
      dispatch(
        actions.showModal({
          type: MODAL_TYPES.CONFIRM,
          size: ModalSize.NORMAL,
          className: "delete-company-confirm",
          props: {
            heading: "Delete Company",
            content:
              isSuperAdmin && (contact.chargebee_customer_id || contact.hubspot_company_id)
                ? "There are links to HubSpot and Chargebee. Do you still want to proceed with deletion? This deletion operation includes all company records, including users, subscriptions, and files. It will be permanent and cannot be restored."
                : `Are you sure you want to delete the company "${
                    contact!.name
                  }"? All information about this company, including users and subscriptions, will be permanently deleted.`,
            cancelBtnText: "Cancel",
            cancelBtnStyle: "blue-bordered",
            successBtnText: "Delete",
            successBtnStyle: "accent-red",
            onSuccess: () => {
              dispatch(
                AccountActions.deleteAccount.request({
                  id: contact!.id,
                  callback: () => {
                    navigate(`${NameOfChildRoutes.CONTACT.ROOT}${NameOfChildRoutes.CONTACT.LIST}`);
                  },
                }),
              );

              dispatch(actions.hideOverlay());
            },
          },
        }),
      );
    },
    [dispatch, navigate, isSuperAdmin],
  );
};
